// UserContext.js
import React, { createContext, useState, useEffect } from "react";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState({
    id: "",
    name: "",
    roles: [],
    isLoading: true,
  });

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_API}api/current_user/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            credentials: "include",
          },
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }

        setUserInfo({
          ...data,
          roles: data.roles || [],
          isLoading: false,
        });
      } catch (error) {
        console.error("Error fetching user details:", error);

        setUserInfo({
          id: "",
          image:
            "https://cdn-redmaestra-endpoint.azureedge.net/media/Profesionales/Diego_Achurra.png",
          name: "Diego Achurra",
          roles: ["Gerencia","Desarrollador"],
          isLoading: false,
        });
      }
    };

    fetchUserInfo();
  }, []);

  return (
    <UserContext.Provider value={userInfo}>{children}</UserContext.Provider>
  );
};